/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { JunctionBoxFamilyInformation } from '../../components/add-family-information/junction-box-family-information/junction-box-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class JunctionBoxFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = JunctionBoxFamilyInformation;
    sysquePopupConfig.width = 1080;
    sysquePopupConfig.height = 815;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}